import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        /* full screen height - (height of global header-10px buffer) */
        height: 'calc(100vh - 140px)',
        width: '100%',
        paddingRight: theme.spacing(4),
    },
    root__layout: {
        width: '100%',
        marginLeft: theme.spacing(4),
        position: 'relative',
        flex: '1', // Allow the root layout to grow and shrink as needed
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
    },
}));
